import { createPromiseActionTypes } from "../../utils/redux";

export const COUNTRIES_CLEAR = "phone/COUNTRIES_CLEAR";
export const COUNTRY_SET = "phone/COUNTRY_SET";
export const COUNTRIES_GET = createPromiseActionTypes("phone/COUNTRIES_GET");
